/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated returns`)
};

const es_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retornos estimados`)
};

const de_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschätzte Renditen`)
};

const nl_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschatte rendement`)
};

const fr_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendements estimés`)
};

const it_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimenti stimati`)
};

const pt_br2_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retornos estimados`)
};

const pt_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retornos estimados`)
};

const ja_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定リターン`)
};

const zh_sip_result_returns = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预计收益`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_result_returns = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_result_returns(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_result_returns", locale)
	if (locale === "en") return en_sip_result_returns(inputs)
	if (locale === "es") return es_sip_result_returns(inputs)
	if (locale === "de") return de_sip_result_returns(inputs)
	if (locale === "nl") return nl_sip_result_returns(inputs)
	if (locale === "fr") return fr_sip_result_returns(inputs)
	if (locale === "it") return it_sip_result_returns(inputs)
	if (locale === "pt-BR") return pt_br2_sip_result_returns(inputs)
	if (locale === "pt") return pt_sip_result_returns(inputs)
	if (locale === "ja") return ja_sip_result_returns(inputs)
	return zh_sip_result_returns(inputs)
};